import React, { useEffect, useCallback, memo, useMemo } from "react";
import { Key } from "uikit";

import { Language, languageOptions } from "../../../assets/languages/langs";
import { useAppContext } from "../../../context";
import { Select2 } from "..";

const LanguageSelect: React.FC<LanguageSelect.Props> = ({
	onSelect,
	value,
}) => {
	const { languageExclude, language } = useAppContext();

	const _value = useMemo(() => value || language, [language, value]);

	const selectOptions = useMemo<LanguageSelect.LanguageSelectElements>(
		() =>
			languageOptions.filter((item) =>
				languageExclude.includes(item.value),
			),
		[languageExclude],
	);

	const onChangeSelect = useCallback(
		(event: LanguageSelect.LanguageSelectElement) => {
			if (value === event.value) return;

			onSelect(event);
		},
		[onSelect, value],
	);

	useEffect(() => {
		if (selectOptions.length > 0) {
			const matchingOption = selectOptions.find(
				(option) => option.value === _value,
			);
			if (matchingOption) {
				onChangeSelect(matchingOption);
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [selectOptions, _value]);

	return (
		<Select2
			value={_value}
			options={selectOptions}
			onSelect={onChangeSelect}
			w="130px"
			isLoading={!languageExclude.length}
		/>
	);
};

declare namespace LanguageSelect {
	interface Props {
		onSelect: (value: LanguageSelectElement) => void;
		value?: Language;
	}

	interface LanguageSelectElement {
		key: Key;
		label: string;
		value: Language;
	}

	type LanguageSelectElements = LanguageSelectElement[];
}

export const LanguageSelectMemo = memo(LanguageSelect);
export default LanguageSelect;
